import { render, staticRenderFns } from "./overseas_user.vue?vue&type=template&id=b39d3bec&scoped=true&"
import script from "./overseas_user.vue?vue&type=script&lang=js&"
export * from "./overseas_user.vue?vue&type=script&lang=js&"
import style0 from "./overseas_user.vue?vue&type=style&index=0&id=b39d3bec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39d3bec",
  null
  
)

export default component.exports